var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.252 7.011a3.152 3.152 0 01-4.453 0c-.594-.595-.922-1.385-.922-2.226s.328-1.632.922-2.226a3.128 3.128 0 012.227-.923c.84 0 1.631.328 2.226.923.594.594.922 1.385.922 2.226 0 .84-.328 1.631-.922 2.226m.514-4.967A3.85 3.85 0 0011.026.91a3.85 3.85 0 00-2.741 1.135 3.851 3.851 0 00-1.135 2.74c0 .914.314 1.778.89 2.472l-2.41 2.41-4.25 4.25a.363.363 0 00.256.622.365.365 0 00.258-.107l1.726-1.727 2.145 2.145a.361.361 0 00.514 0 .363.363 0 000-.514L4.134 12.19l1.753-1.752 2.145 2.144a.361.361 0 00.514 0 .363.363 0 000-.514L6.4 9.923 8.555 7.77a3.87 3.87 0 002.47.889 3.86 3.86 0 002.74-1.134 3.846 3.846 0 001.136-2.74 3.848 3.848 0 00-1.135-2.74",
    fill: "#333",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "ec1cefef486ac1990ea5dc0cf4cd94c6.svg";
export { SvgIconKey as ReactComponent };